import { computable, iterable, mix, observable, patch } from "@chorda/core";
export const Pagination = (props) => {
    return mix({
        css: 'pagination',
        tag: 'nav',
        templates: {
            previous: {
                css: 'pagination-previous'
            },
            next: {
                css: 'pagination-next'
            },
            list: {
                tag: 'ul',
                css: 'pagination-list',
                defaultComponent: {
                    tag: 'li',
                    templates: {
                        content: {
                            tag: 'a',
                            css: 'pagination-link',
                            reactions: {
                                __item: v => ({ text: String(v) }),
                                active: v => ({ classes: { 'is-current': v } })
                            },
                            events: {
                                $dom: {
                                    click: (e, { current, __item }) => {
                                        current.$value = __item;
                                    }
                                }
                            }
                        }
                    },
                    injections: {
                        active: $ => computable(() => {
                            return $.current == $.__item;
                        })
                    }
                },
                reactions: {
                    __it: v => patch({ components: v })
                }
            }
        },
        components: {
            previous: false,
            next: false,
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        defaults: {
            maxPages: () => observable(props.maxPages),
            current: () => observable(1),
        },
        injections: {
            pages: $ => computable(() => {
                const pages = {};
                for (let i = 0; i < $.maxPages; i++) {
                    pages[i + 1] = i + 1;
                }
                return pages;
            }),
            maxPages: props.maxPages$,
            __it: $ => iterable($.pages, '__item'),
            current: props.current$,
        }
    });
};
